export default __webpack_public_path__ + "static/media/FlyingFrog4.2b7b43a1.png";